import "./calendarMarker.scss";

import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import Icon from "../../components/interface/Icon";
import { CALENDAR_MARKER_DOT_WIDTH, CALENDAR_MARKER_ICON_WIDTH, CALENDAR_MARKER_MIN_BAR_WIDTH } from "../../constants";
import { scalePixelsToFontSize } from "../../constants/styles/dimensions";
import { getLabelWithUntitled } from "../../utils/labelUtils";

// import debugUtils from "../../utils/debugUtils";

class CalendarMarkerView extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.onClick = this.onClick.bind(this);
  }

  // componentWillReceiveProps(nextProps) {
  //   debugUtils.logPropChanges("MindmapCanvasView", this.props, nextProps, true);
  // }

  onClick() {
    this.props.onClick(this.props.id);
  }

  render() {
    const SCALED_MARKER_WIDTH = scalePixelsToFontSize(
      this.props.icon ? CALENDAR_MARKER_ICON_WIDTH : CALENDAR_MARKER_DOT_WIDTH,
      this.props.fontSize
    );
    const width = Math.max(this.props.width, SCALED_MARKER_WIDTH);
    let classNames = "calendarMarker";
    if (width < CALENDAR_MARKER_MIN_BAR_WIDTH) {
      classNames += " thin";
    }
    if (this.props.icon) {
      classNames += " hasIcon";
    }
    const style = {
      width: `${width}px`
    };
    Object.assign(style, this.props.style);

    return (
      <div className={classNames} style={style} onClick={this.onClick} title={getLabelWithUntitled(this.props.label)}>
        {this.props.icon ? <Icon icon={this.props.icon} color={this.props.color} /> : null}
        {!this.props.icon || width > CALENDAR_MARKER_MIN_BAR_WIDTH ? (
          <div className={`calendarMarkerArea ${this.props.color}`} />
        ) : null}
      </div>
    );
  }
}

CalendarMarkerView.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  color: PropTypes.string.isRequired,
  icon: PropTypes.string,
  width: PropTypes.number.isRequired,
  fontSize: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired,
  onClick: PropTypes.func
};

export default CalendarMarkerView;
